import { render, staticRenderFns } from "./AttachmentCache.vue?vue&type=template&id=68db765f&scoped=true&"
import script from "./AttachmentCache.vue?vue&type=script&lang=js&"
export * from "./AttachmentCache.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentCache.vue?vue&type=style&index=0&id=68db765f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db765f",
  null
  
)

export default component.exports